export const SHOP_ORDER_STATUSES = [
  { id: 'pending', label: 'Chờ xác nhận', color: '#888888' },
  { id: 'confirmed', label: 'Đã xác nhận', color: '#003DB0' },
  { id: 'wait_print', label: 'Chờ in', color: '#D65A9A' },
  { id: 'printed', label: 'Đã in', color: '#B0005D' },
  { id: 'packing', label: 'Đang đóng hàng', color: '#6D28D9' },
  { id: 'wait_transfer', label: 'Chờ chuyển', color: '#E22D90' },
  { id: 'shipped', label: 'Đã gửi', color: '#F08715' },
  { id: 'received', label: 'Đã nhận', color: '#51C21A' },
  { id: 'cancelled', label: 'Đã hủy', color: '#EF212C' },
  { id: 'returned', label: 'Đã hoàn', color: '#A5071A' },
  { id: 'returning', label: 'Đang hoàn', color: '#DC675A' },
];

export function shopOrderStatusLabel(id) {
  return SHOP_ORDER_STATUSES.find((s) => s.id === id)?.label || id;
}

export function shopOrderStatusColor(id) {
  return SHOP_ORDER_STATUSES.find((s) => s.id === id)?.color || '#888888';
}

export function formatVnd(value) {
  return new Intl.NumberFormat('vi-VN').format(Number(value) || 0);
}
